import React from "react";

const SvgPlusLight = props => <svg width={32} height={32} viewBox="0 0 32 32" {...props}><path d="M16.5 0h-1v15.5H0v1h15.5V32h1V16.5H32v-1H16.5V0z" stroke="currentColor" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/plus-light_925b20.svg";
export { SvgPlusLight as ReactComponent };